import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
} from 'react';

export type AccordionEvent =
  | React.MouseEvent<HTMLElement>
  | React.KeyboardEvent<HTMLElement>;

export interface AccordionContextType {
  onClick?: (event: AccordionEvent, ...args: any[]) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  index: number;
  question: string;
  answer: ReactNode;
}

export const AccordionContext = createContext<AccordionContextType>({
  open: false,
  setOpen: () => {},
  index: 0,
  question: '',
  answer: <></>,
});
